'use strict';

/** @type {import('.')} */
module.exports = Error;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/index.js
// module id = 241
// module chunks = 0 15 16 17 18